import { useAtomValue } from 'jotai';
import LogRocket from 'logrocket';
import { ReactNode, useEffect } from 'react';
import { loadableUserDetailsAtom } from '@/atoms/queries/user';
import env from '@/env';
import { isAutomationUser } from '@/utils/user';

const LogRocketIdentityProvider = ({ children }: { children: ReactNode }) => {
  const userDetails = useAtomValue(loadableUserDetailsAtom);

  const userData = userDetails?.state === 'hasData' ? userDetails.data.data : null;
  const { email, name } = userData?.user || { email: '', name: '' };

  useEffect(() => {
    if (email && !isAutomationUser(userData)) {
      LogRocket.identify(email, { name: name || '', email });
    }
  }, [email, userData]);
  return children;
};

export const SessionReplayIdentityProvider = ({ children }: { children: ReactNode }) =>
  Number(env.VITE_ENABLE_LOGROCKET) ? <LogRocketIdentityProvider>{children}</LogRocketIdentityProvider> : children;
